import React, { useCallback } from 'react';
import { View } from 'react-native';
import Button from 'design-system/Button';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import LogoBankAccount from 'design-system/LogoBankAccount';
import BankConnectionStatus from './BankConnectionStatus';
const strings = {
    renewConnection: 'Renew connection',
    closeConnection: 'Close connection',
};
const BrokenConnectionCard = ({ data, onClose, onRenew, hideClose, isClosing }) => {
    const styles = useStyles(styleSet);
    const handleClose = useCallback(() => {
        onClose(data);
    }, [data, onClose]);
    const handleRenew = useCallback(() => {
        onRenew(data);
    }, [data, onRenew]);
    return (<View style={styles.container}>
      <View style={styles.rowInfo}>
        <LogoBankAccount data={data.bankInfo} size="R44" onCard/>
        <View>
          <Text Text-16>{data.bankInfo.name}</Text>
          <BankConnectionStatus data={data}/>
        </View>
      </View>

      <Spacer h={24}/>

      {data.statusMessage != null ? (<View>
          <Text TextThin-14 Negative>
            {data.statusMessage}
          </Text>
          <Spacer.H16 />
        </View>) : null}

      <Button errorReversed square title={strings.renewConnection} onPress={handleRenew} preventDoubleTap disabled={isClosing}/>
      {!hideClose && (<>
          <Spacer h={12}/>
          <Button brandBorder square title={strings.closeConnection} onPress={handleClose} preventDoubleTap isFetching={isClosing}/>
        </>)}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        marginHorizontal: rem(16),
        borderRadius: rem(16),
        backgroundColor: colors.cards.onDark,
        padding: rem(16),
    },
    rowInfo: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: rem(16),
    },
}));
export default BrokenConnectionCard;
